import {
  installUsOptOutSignal,
  resetUsOptOutSignal,
} from '@redbrickmedia/duplex.user-identity'
import { isDebugEnabled } from '../debug/isDebugEnabled'
import { markConsentTiming } from './consentTiming'

let installed = false

export function ensureUsOptOutSignal(): void {
  if (!import.meta.client || installed) {
    return
  }

  installUsOptOutSignal({ debug: isDebugEnabled() })
  installed = true
  markConsentTiming('us-opt-out-signal-installed', true)
}

export function resetUsOptOutSignalForTests(): void {
  resetUsOptOutSignal()
  installed = false
}

if (import.meta.client) {
  ensureUsOptOutSignal()
}
